import colors from 'theme/ui/colors'

export const TOP_LOADER_CONSTANTS = {
  DEFAULT_HEIGHT: 4,
  DEFAULT_HEIGHT_MOBILE: 2,
  DEFAULT_COLOR: colors.primary,

  PROGRESS_INCREMENT: 20,
  PROGRESS_DELAY: 80,
  START_DELAY: 10,
  MAX_PROGRESS_BEFORE_COMPLETE: 90,
  MAX_PROGRESS: 100,

  RESET_DELAY: 400,
} as const
